import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { AutoFocusInside } from 'react-focus-lock';
import Box from 'components/Box';
import Heading from 'components/Heading';
import Text from 'components/Text';
import PageSection from 'components/PageSection';
import ThemedBox from 'components/ThemedBox';
import ToolbarButton from 'components/ToolbarButton';
import Modal from 'components/Modal';
export function ExampleDescription(_ref) {
  var titleKey = _ref.titleKey,
    descriptionKey = _ref.descriptionKey;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(Box, {
    mb: "s"
  }, /*#__PURE__*/React.createElement(Heading, {
    as: "h2"
  }, t(titleKey)), /*#__PURE__*/React.createElement(Text, {
    dimmed: true
  }, /*#__PURE__*/React.createElement(Trans, {
    t: t,
    i18nKey: descriptionKey
  })));
}
export function MainThumbnailPreviewModalWrapper(_ref2) {
  var id = _ref2.id,
    pageSections = _ref2.pageSections,
    buttonText = _ref2.buttonText,
    children = _ref2.children,
    onClose = _ref2.onClose;
  var _useTranslation2 = useTranslation(),
    t = _useTranslation2.t;
  return /*#__PURE__*/React.createElement(Modal, {
    id: id,
    layout: "fullscreen",
    "aria-label": t('actions_review_cover_image'),
    onRequestClose: onClose
  }, /*#__PURE__*/React.createElement(ThemedBox, {
    name: "page",
    height: "100%",
    overflow: "auto"
  }, /*#__PURE__*/React.createElement(ToolbarButton, {
    position: "absolute",
    top: "xs",
    right: "xs",
    icon: "x",
    title: buttonText || t('actions_close'),
    onClick: onClose
  }), /*#__PURE__*/React.createElement(PageSection, null, /*#__PURE__*/React.createElement(AutoFocusInside, null, children)), pageSections));
}